var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-check-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-check-circle",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF00C",
    transform: "translate(4.125000, 6.625000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4335938,0.31640625 C15.6445312,0.55078125 15.75,0.8203125 15.75,1.125 L15.75,1.125 C15.75,1.4296875 15.6445312,1.69921875 15.4335938,1.93359375 L6.43359375,10.9335938 C6.19921875,11.1445312 5.9296875,11.25 5.625,11.25 C5.3203125,11.25 5.05078125,11.1445312 4.81640625,10.9335938 L0.31640625,6.43359375 C0.10546875,6.19921875 0,5.9296875 0,5.625 C0,5.3203125 0.10546875,5.05078125 0.31640625,4.81640625 C0.55078125,4.60546875 0.8203125,4.5 1.125,4.5 C1.4296875,4.5 1.69921875,4.60546875 1.93359375,4.81640625 L5.625,8.54296875 L13.8164062,0.31640625 C14.0507812,0.10546875 14.3203125,0 14.625,0 C14.9296875,0 15.1992188,0.10546875 15.4335938,0.31640625 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic-check.d73ca9286d40a05bfacc57d29c2acf66.svg";
export { ForwardRef as ReactComponent };